import styled from 'styled-components';
import {themeGet} from '@styled-system/theme-get';

const FooterWrapper = styled.footer`
  position: relative;
  align-items: center;
  font-size: ${themeGet('fontSizes.3', '15')}px;
  padding-bottom: 100px;

  .border-line {
    border-bottom: 1px solid ${({theme}) => theme.semiforeground};
    margin-bottom: 50px;
    background-color: green;
  }

  .shoe {
    cursor: default;
    width: 330px;
    margin: auto;
    display: flex;
    justify-content: space-evenly;
    @media (max-width: 330px) {
      width: 100%;
      display: grid;
      justify-content: center;
      line-height: 1.5em;
      #❤️ {
        margin: auto;
      }
    }

    a {
      color: ${({ theme }) => theme.text};
    }

  }

  #❤️ {
    cursor: grab;
    transform: translateY(-2px);
  }

  span:not(#❤️) {
    text-align: right;
    width: 120px;
  }

  #❤️:hover {
    transition: transform ease-out .2s;
    transform: scale(1.2) translateY(-2px);;
  }
}
`;

export default FooterWrapper;
